import React, { Component, useEffect, useRef, useState } from "react";
import { Checkbox, Row, Col, Select } from "antd";

import {
  parseFormControlValue,
  isObject,
  createDefaultValueObject,
  generateUUID,
  showDropdownSearch,
  isSearchMobile,
  getWindowWidth,
  isMobileScreen
} from "../../../services/utils";
import styles from "./multiFieldSelector.scss";
import MultiSelectModal from "../MultiSelectModal";

const MultiFieldSelector = props => {
  const { title, options, showPlaceholder, getPopupContainer } = props;

  const [focus, setFocus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fields, setFields] = useState(options.map(opt => opt.field));
  const id = generateUUID();
  const selectRef = useRef();

  useEffect(() => {
    const { options } = props;
    
    if (!showDropdownSearch(options.length)) {
      const selectElement = document.getElementById(id);
      // @ts-ignore
      if (selectElement && !selectElement.readOnly) {
        // @ts-ignore
        selectElement.readOnly = true;
      }
    }
  });

  function getValue() {
    const { value } = props;
    const values = [];

    isObject(value) &&
      Object.keys(value).forEach(property => {
        if (value[property]) {
          values.push(property);
        }
      });

    return values;
  }

  const handleChange = values => {
    const { onChange } = props;

    const parsedValue = parseFormControlValue(
      values,
      Array(values.length).fill(true)
    );

    const defaultValue = createDefaultValueObject(fields);

    onChange({ ...defaultValue, ...parsedValue });
  };

  const renderStringTitles = selectedOptions => {
    const titleOptionsSelected = props.options
      .filter(item => selectedOptions.includes(item.field))
      .map(item => item.title);

    if (titleOptionsSelected.length === 0) {
      return null;
    }

    return titleOptionsSelected.join(", ");
  };

  const handleSelectFocus = () => {
    setFocus(true);
    // @ts-ignore
    selectRef.current.focus();
  };

  const handleSelectBlur = () => {
    setFocus(false);
    // @ts-ignore
    selectRef.current.blur();
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    if (selectRef.current) {
      // @ts-ignore
      selectRef.current.focus();
    }
  };

  const renderContent = () => {
    const { options, fullWidth, placeholder, showPlaceholder, title } = props;
    const mobile = isSearchMobile(getWindowWidth())

    if (options.length < 3) {
      return (
        <Checkbox.Group
          className={styles.checkboxWrapper}
          value={getValue()}
          onChange={handleChange}
        >
          <Row type="flex" align="top">
            {options.map((option, index) => (
              <Col
                key={index /* eslint-disable-line */}
                xs={24}
                lg={12}
                className={`${styles.checkboxItemWrapper} ${
                  fullWidth ? styles.fullWidth : ""
                }`}
              >
                <Checkbox value={option.field}>{option.title}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      );
    }

    const selectValue = focus
      ? getValue().map(String)
      : renderStringTitles(getValue());

    return (
      <Select
        // @ts-ignore
        id={id}
        className={mobile ? styles.mobileContent : styles.desktopSelect}
        mode={focus ? "multiple" : "default"}
        onChange={handleChange}
        onBlur={handleSelectBlur}
        onFocus={handleSelectFocus}
        value={selectValue || undefined}
        ref={selectRef}
        placeholder={showPlaceholder ? title : placeholder}
        notFoundContent={"Nema rezultata"}
        getPopupContainer={getPopupContainer}
      >
        {options.map((option, index) => (
          <Select.Option
            key={index /* eslint-disable-line */}
            value={option.field}
          >
            {option.title}
          </Select.Option>
        ))}
      </Select>
    );
  };

  return (
    <React.Fragment>
      {showPlaceholder ? null : title ? (
        <span className="control-title">{title}</span>
      ) : null}
      {isSearchMobile(getWindowWidth()) && options.length > 2 ? (
        <React.Fragment>
          <MultiSelectModal
            title={title}
            options={options.map((option) => ({
              value: option.field,
              title: option.title,
            }))}
            value={getValue()}
            onCancel={closeModal}
            visible={showModal}
            onOk={handleChange}
          />
          <div
            role="button"
            tabIndex={-1}
            onClick={handleShowModal}
            style={{ position: "relative" }}
          >
            <div style={{ position: "absolute", inset: 0, zIndex: 1 }}></div>
            {renderContent()}
          </div>
        </React.Fragment>
      ) : (
        renderContent()
      )}
    </React.Fragment>
  );
};

MultiFieldSelector.defaultProps = {
  title: "",
  onChange: () => null,
  fullWidth: false,
  placeholder: "Odaberite",
  showPlaceholder: false
};

export default MultiFieldSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiFieldSelector/MultiFieldSelector.tsx